// Centralised external links. Override per environment via .env:
//   REACT_APP_FAMILY_PORTAL_URL  — registration / family portal
//   REACT_APP_MAIN_SITE_URL      — main marketing site (logo click target)
//   REACT_APP_DONATION_URL       — Zeffy donation form base URL

export const FAMILY_PORTAL_URL =
  process.env.REACT_APP_FAMILY_PORTAL_URL ||
  "https://familyportal.thebookshelfproject.org/login";

export const MAIN_SITE_URL =
  process.env.REACT_APP_MAIN_SITE_URL ||
  "https://www.thebookshelfproject.org";

export const DONATION_URL =
  process.env.REACT_APP_DONATION_URL ||
  "https://www.zeffy.com/en-US/donation-form/f13a6f55-c455-4c81-ae9e-deb05b8c14af";

/**
 * Build a Zeffy donation URL with UTM tags. We keep `utm_medium` distinct
 * (pin-popup vs share-card) so you can still tell which surface drove the
 * click, but campaign is now a single fixed value — no per-neighborhood
 * tracking, just one "Sponsor a Library" funnel.
 */
export function donationUrlFor(source = "pin-popup") {
  const params = new URLSearchParams({
    utm_source: "impact-map",
    utm_medium: source,
    utm_campaign: "sponsor-a-library",
  });
  return `${DONATION_URL}?${params.toString()}`;
}
